import { Location, CommonModule } from "@angular/common";
import { Component, OnInit, inject, signal, DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { filter } from "rxjs/operators";

import { FooterComponent } from "../../components/footer/footer.component";
import { ROUTES, RouteInfo } from "../../components/sidebar/sidebar.component";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbModule, FooterComponent]
})
export class AuthLayoutComponent implements OnInit {
  private location = inject(Location);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  private listTitles = signal<RouteInfo[]>([]);
  isCollapsed = signal(false);

  ngOnInit() {
    this.listTitles.set(ROUTES.filter(listTitle => listTitle));
    
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.isCollapsed.set(false);
      this.updateNavbarClass();
    });
  }

  getTitle() {
    const titlee: string = this.location.prepareExternalUrl(this.location.path());
    const titles = this.listTitles();
    
    for (let i = 0; i < titles.length; i++) {
      const title = titles[i];
      if (title.type === "link" && title.path === titlee) {
        return title.title;
      } else if (title.type === "sub" && title.children) {
        for (let j = 0; j < title.children.length; j++) {
          const child = title.children[j];
          const subtitle = title.path + "/" + child.path;
          if (subtitle === titlee) {
            return child.title;
          }
        }
      }
    }
    return "Nasti Pannello Controllo";
  }

  collapse() {
    this.isCollapsed.update(v => !v);
    this.updateNavbarClass();
  }

  private updateNavbarClass() {
    const navbar = document.getElementsByTagName('nav')[0];
    if (!navbar) return;

    if (this.isCollapsed()) {
      navbar.classList.remove('navbar-transparent');
      navbar.classList.add('bg-white');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }
  }
}
